export type FirmwareFamily = 'ahu2020_hmi'

export function translate(family: FirmwareFamily): string {
  switch (family) {
    case 'ahu2020_hmi':
      return 'AHU2020 HMI'
  }
}
